import React, { useState,useEffect} from 'react';
import {  Form, Select, Button,  useDispatch, useSelector, Radio, message } from '../../AntComponent';
import { saveMilestoneConfig, getMilestoneConfig } from '../../../store/actions/configuration-setting/ProjectConfigSettingAction';

export default function ProjectConfigSetting(){
    const [form] =  Form.useForm();
    const dispatch = useDispatch(); 
    const { profileInfo } = useSelector(state => state.userPrf);
    const {getMilConfig, success, saveMilConfig, loading} = useSelector(state => state.projectConfig)
    const tenantID = profileInfo?.data?.appUser?.tenantID;
    const locationID = profileInfo?.data?.location[0]?.locationID;
    const configID = getMilConfig?.data[0]?.configID;
    const [showSuccessmsg, setShowsuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success : null;
    const [selectedRadio, setSelectedRadio] = useState("");

    const handleRadioChange = (e) => {
        setSelectedRadio(e.target.value);
    };

    function getMilestoneConfiguration () {
        let inputJson = {
            "ServiceName": "MilestoneMode",
            "IdentifierType": "MilestoneMode",
            "TenantID": tenantID,
            "LocationID": locationID
        }
        dispatch(getMilestoneConfig(inputJson))
    }

    useEffect(()=>{
        if(successmsg){
            if(saveMilConfig?.message == "Updated Successfully"){
                message.success("Milestone Status Updated Successfully")
                setShowsuccessmsg(false)
                getMilestoneConfiguration()
            }
            else{
                message.error(saveMilConfig?.message);
            }
        }
    },[successmsg])

    useEffect(()=>{
        form.setFieldsValue({
            milestoneStatus: String(getMilConfig?.data[0]?.generateMode),
          })
          setSelectedRadio(getMilConfig?.data[0]?.generateMode)
    }, [getMilConfig?.data[0]?.generateMode])

    useEffect(() => {
       getMilestoneConfiguration()
    }, [dispatch, tenantID]);

    const handleMilStatus  = (values) =>{
        let val = values;
        let inputJson = {
            "ConfigID": configID,
            "ServiceName": "MilestoneMode",
            "IdentifierType": "MilestoneMode",
            "GenerateMode":val.milestoneStatus ,
            "IsActive": true,
            "TenantID": tenantID,
            "LocationID": locationID
        }
        dispatch(saveMilestoneConfig(inputJson))
        setShowsuccessmsg(true)
    }
    return(
        <div className='m-3 mt-1'>
            <Form
            className='configSettingCont'
            form = {form}
            onFinish={handleMilStatus}
            // initialValues={{ milestoneStatus:  String(checkedValue) == "Auto" ? "Auto" : "Manual" }}
            layout='vertical'>
            <div>
                <h5 className='p-2 prjConfigHead'>Milestone Completion Status</h5>
            </div>
            <div className='TemplateDrawer row m-0'>
                <Form.Item name="milestoneStatus" label="">
                    <Radio.Group onChange={handleRadioChange} value={selectedRadio}>
                        <Radio value="Auto">Auto-Complete</Radio>
                        <Radio value="Manual">Manual</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item>
                    {selectedRadio === 'Auto' && (
                        <p className='mb-0'>
                            By selecting this option, the milestone completion status will be automatically updated when all tasks are completed, and mandatory deliverables are uploaded.
                        </p>
                    )}

                    {selectedRadio === 'Manual' && (
                        <p className='mb-0'>
                        By selecting this option, you can manually update the milestone completion status even after tasks are completed and deliverables are uploaded.
                        </p>
                    )}
                </Form.Item>
            </div>
            <div className='row m-0 d-flex justify-content-end'>
                <Button className='dlv-save-btn m-4 mt-2' type="primary save-btn ms-1" htmlType='submit' loading={loading} >Save</Button>
            </div>

            </Form>
        </div>
    )
}